module.exports = __webpack_public_path__ + "img/catch02.569ebb28.jpg";